<template>
  <div class="candidate-list-card card mt-4">
    <div class="table-controls m-3">
      <div class="controls-wrap d-flex">
        <Search placeholderText="Search (name and email)" @search="doSearch" />

        <v-select
          :style="{ width: '35%', marginLeft: 'auto' }"
          v-model="listOfSelectedJobs"
          @input="handleJobFilter($event)"
          :options="getManagerJobsDropdown"
          placeholder="All Jobs"
          inputId="manager-jobs-select"
          label="job_name"
          :reduce="job => job"
          :clearable="true"
          :multiple="true"
          class="mobile-searchable"
        >
          <template #option="{ job_name, city }"> {{ job_name }}, {{ city.name }}</template>
          <template #selected-option="{ job_name, city }">
            {{ job_name }}, {{ city.name }}
          </template>
          <template v-slot:no-options>
            <div style="opacity: 0.5">
              <span v-if="isJobsLoading">Loading...</span>
              <span v-else>
                {{ getJobListMsg }}
              </span>
            </div>
          </template>
        </v-select>
      </div>
    </div>

    <Spinner :isLoading="isLoading" />

    <div
      class="table-responsive hide-on-mobile"
      :style="getManagerCandidates.length === 0 ? 'overflow-y:hidden; padding-bottom:5px' : ''"
    >
      <table class="table table-striped custom-table ">
        <thead class="bg-dark">
          <tr>
            <th nowrap scope="col">NAME</th>
            <th nowrap scope="col">LOCATION</th>
            <th nowrap scope="col" style="text-align: center">&nbsp;</th>
            <th nowrap scope="col" style="width: 100px">UPDATED</th>
            <th nowrap scope="col" style="width: 260px">COMPETENCIES</th>
            <th nowrap scope="col">RECENT STAGE</th>
            <th class="extend-on-bigscreen" nowrap scope="col">RECENT JOB</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="candidate in getManagerCandidates" :key="candidate.id">
            <td id="candidate-name" class="candidate-name" nowrap>
              <del v-if="candidate.status == 102"
                >{{ candidate.first_name }} {{ candidate.last_name }}</del
              >

              <popper
                v-else
                trigger="hover"
                :options="{
                  placement: 'top',
                  modifiers: { offset: { offset: '-60,10px' } },
                }"
              >
                <div class="popper">{{ candidate.first_name }} {{ candidate.last_name }}</div>
                <div slot="reference">
                  <router-link
                    :to="{
                      name: 'manager_candidate_id',
                      params: { manager_candidate_id: candidate.id },
                    }"
                  >
                    {{ candidate.first_name }} {{ candidate.last_name }}
                  </router-link>
                </div>
              </popper>
            </td>
            <td id="candidate-location" nowrap>
              {{ getLocation(candidate) }}
            </td>
            <!-- MODEL -->
            <td style="right: 0" id="candidate-employment">
              <div class="employment-type d-flex align-items-center justify-content-center">
                <svgHelper
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  :title="`Relocation: ${candidate.relocation ? 'Yes' : 'No'}`"
                  style="margin-right: 10px"
                  slot="reference"
                  :name="candidate.relocation ? 'relocate' : 'relocateFalse'"
                ></svgHelper>
                <!-- getEmploymentType from mixin! -->
                <svgHelper
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  :title="`${getEmploymentType(candidate.employment).name}`"
                  slot="reference"
                  :name="getEmploymentType(candidate.employment).name"
                ></svgHelper>
              </div>
            </td>
            <!-- END MODEL -->

            <td id="candidate-updated" class="popover-show" nowrap>
              <div>
                {{
                  candidate.updated_at
                    | formatDate({
                      format: getManagerUserProfile.format_date,
                      timezone: getManagerUserProfile.timezone,
                      hasHourAndMinutes: false,
                    })
                }}
              </div>
            </td>
            <td class="candidate-competences" id="candidate-competences">
              <div class="tech-icons d-flex flex-nowrap align-items-center">
                <div
                  class="text-center icon-container d-flex"
                  v-for="(competence, $index) in getCompetences(candidate.competences)"
                  :key="$index"
                >
                  <IconMapper :competence="competence" />
                </div>
                <i v-if="candidate.competences.length > 4" class="fas fa-ellipsis-h ml-2"></i>
                <div class="dropdown">
                  <button
                    v-show="candidate.competences.length > 4"
                    type="button"
                    class="btn btn-danger dropdown-toggle"
                    id="competencesDropDown"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  ></button>

                  <ul class="list-inline dropdown-menu w-100" aria-labelledby="competencesDropDown">
                    <li
                      v-for="(c, i) in getRestCompetences(candidate.competences)"
                      :key="i"
                      class="list-inline-item"
                    >
                      <IconMapper :competence="c" />
                    </li>
                  </ul>
                </div>
              </div>
            </td>
            <td id="stage">
              <div class="d-flex align-items-center">
                <span
                  :class="[
                    getStageColorClass(candidate['recent-stage'].stage),
                    'flex-shrink-0',
                    'stage-size',
                    'rounded-circle',
                    'mr-2',
                  ]"
                ></span>
                <span
                  :class="[
                    getStageMixin(candidate['recent-stage'].stage).title ? 'text-nowrap' : 'mr-0',
                    'stage-text',
                  ]"
                  >{{ getStageMixin(candidate['recent-stage'].stage).title }}
                </span>
              </div>
            </td>
            <td id="candidate-recent-job">
              <router-link
                class="text-nowrap"
                v-if="candidate['recent-stage'].job"
                :to="{
                  name: 'manager_job_uuid',
                  params: { manager_job_uuid: candidate['recent-stage']['job_id'] },
                }"
                >{{ candidate['recent-stage'].job }}</router-link
              >
              <div
                style="
                  color: rgb(0, 136, 204);
                  text-decoration: none;
                  background-color: transparent;
                "
                v-else
              >
                N/A
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div @scroll="onScroll" class="mobile-list">
      <ul class="list-unstyled">
        <li class="mobile-list-item" v-for="candidate in lazyLoadCandidates" :key="candidate.id">
          <div class="header">
            <div>
              <router-link
                :to="{
                  name: 'manager_candidate_id',
                  params: { manager_candidate_id: candidate.id },
                }"
              >
                {{ candidate.first_name }} {{ candidate.last_name }}
              </router-link>
              <div class="location">{{ getLocation(candidate) }}</div>
            </div>
            <div class="date">
              {{
                candidate.updated_at
                  | formatDate({
                    format: getManagerUserProfile.format_date,
                    timezone: getManagerUserProfile.timezone,
                    hasHourAndMinutes: false,
                  })
              }}
              <div class="d-flex align-items-center">
                <span
                  :class="[
                    getStageColorClass(candidate['recent-stage'].stage),
                    'flex-shrink-0',
                    'stage-size',
                    'rounded-circle',
                    'mr-2',
                  ]"
                ></span>
                <span
                  :class="[
                    getStageMixin(candidate['recent-stage'].stage).title ? 'text-nowrap' : 'mr-0',
                    'stage-text',
                  ]"
                  >{{ getStageMixin(candidate['recent-stage'].stage).title }}
                </span>
              </div>
            </div>
          </div>
          <div class="tech-icons d-flex flex-nowrap align-items-center">
            <div
              class="text-center icon-container d-flex"
              v-for="(competence, $index) in getCompetences(candidate.competences)"
              :key="$index"
            >
              <IconMapper :competence="competence" />
            </div>
          </div>
        </li>
      </ul>
    </div>

    <!--    <ErrorList
      class="no-data-message"
      v-show="getManagerCandidates.length == 0"
      name="noCandidates"
      :phrase="searchText"
    /> -->

    <div v-show="getManagerCandidates.length == 0" class="welcome-text">
      <h3>
        The applicants for your jobs will be shown here. You can easily view their contact details,
        CVs, and other relevant information
      </h3>
    </div>

    <div class="d-flex ml-auto mt-auto bottom-controls ">
      <div class="ml-auto" id="pagination">
        <!-- Pagination -->
        <Pagination
          :currentPage="getCurrentPage"
          :totalPages="getTotalPages"
          @nextPage="nextPage"
          @keyup="keymonitor"
          @prevPage="previousPage"
          @selectPageByNumber="setPageByNumber"
          @firstPage="setToFirstPage"
          @lastPage="setToLastPage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';

import Pagination from '@/components/Navigations/Pagination';
/* import CustomMainModal from '@/components/Modals/CustomMainModal'; */
import Search from '@/components/common/Search/Search';
/* import ManagerAddCandidateBtnModal from './ManagerAddCandidateBtnModal'; */

import IconMapper from '../../common/iconMapper';
import { stagesMixin } from '../../../mixins/stagesMixin';
import { statusMixin } from '../../../mixins/statusMixin';
import { employmentMixin } from '../../../mixins/employmentMixin';
import { displayResultsBasedOnScreenHeightMixin } from '../../../mixins/displayResultsBasedOnScreenHeightMixin';

import { errorService } from '../../../services/errorService';
import { MESSAGES } from '../../../constants';
import ErrorList from '@/components/common/errorsList';
import titleMixin from '../../../mixins/titleMixin';
export default {
  components: {
    Search,
    ErrorList,
    IconMapper,
    Pagination,
    /* CustomMainModal, */
    /*  ManagerAddCandidateBtnModal, */
  },
  mixins: [
    stagesMixin,
    statusMixin,
    employmentMixin,
    displayResultsBasedOnScreenHeightMixin,
    titleMixin,
  ],
  title() {
    return 'Candidates | Jobshark';
  },
  data: () => ({
    searchText: '',
    isLoading: true,
    isOptedOut: false,
    toggleFilter: false,
    showModal: false,
    currentPage: 1,
    pageCount: 10,
    infiniteScrollList: [],
    listOfSelectedJobs: [],
    lazyLoadCandidates: [],
    isJobsLoading: true,
  }),
  methods: {
    ...mapActions('managerStoreModule', [
      'retrieveManagerCandidates',
      'retrieveManagerJobsDropdown',
      'retrieveManagerUserProfile',
      'sendManagerRecent',
      'retrieveManagerCandidatesForMobile',
      /*
      'retrieveEmployersDropdown',
      'searchLocationByName',
      'retrieveSourcesList', */
    ]),
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        this.currentPage++;
        this.retrieveManagerCandidates({
          search_word: this.searchText,
          page: this.currentPage,
          count: this.pageCount,
          selectedJob: this.listOfSelectedJobs.id,
        }).then(() => {
          this.lazyLoadCandidates = [...this.lazyLoadCandidates, ...this.getManagerCandidates];
        });
      }
    },
    keymonitor(event) {
      // who caused it? "event.target.id"
      // console.log('keyup from id: ' + event.target.id);

      // what was pressed?
      let keyMessage = event.key || String.fromCharCode(event.keyCode);

      /* if (event.shiftKey) {
        keyMessage += 'Shift+';
      } */

      if (keyMessage == 'ArrowRight' && !this.showModal) {
        this.nextPage();
      }

      if (keyMessage == 'ArrowLeft' && !this.showModal) {
        this.previousPage();
      }
    },
    closeModal() {
      this.currentPage = 1;
      this.showModal = false;
    },
    reloadDefaultList() {
      this.isLoading = true;

      this.currentPage = 1;

      this.retrieveManagerCandidates({
        search_word: this.searchText,
        page: this.currentPage,
        count: this.pageCount,
        selectedJob: this.listOfSelectedJobs.id,
      })
        .then(() => {
          this.isLoading = false;
          this.lazyLoadCandidates = this.getManagerCandidates;
        })
        .catch(err => {
          this.isLoading = false;

          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
    handleJobFilter() {
      this.isLoading = true;
      this.currentPage = 1;
      this.retrieveManagerCandidates({
        search_word: this.searchText,
        page: this.currentPage,
        count: this.pageCount,
        job_ids: this.listOfSelectedJobs.map(j => j.id),
      })
        .then(() => {
          this.isLoading = false;
          this.lazyLoadCandidates = this.getManagerCandidates;
        })
        .catch(err => {
          this.isLoading = false;

          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
    doSearch(searchedText) {
      this.searchText = searchedText;
      this.currentPage = 1;

      if (this.searchText.length >= 3) {
        this.isLoading = true;

        this.retrieveManagerCandidates({
          search_word: this.searchText,
          page: this.currentPage,
          count: this.pageCount,
          selectedJob: this.listOfSelectedJobs.id,
        })
          .then(() => {
            this.isLoading = false;
            this.lazyLoadCandidates = this.getManagerCandidates;
          })
          .catch(err => {
            this.isLoading = false;

            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 8000,
            });
          });
      }

      if (searchedText === '') {
        this.isLoading = true;
        this.searchText = searchedText;

        this.retrieveManagerCandidates({
          search_word: this.searchText,
          page: this.currentPage,
          count: this.pageCount,
          selectedJob: this.listOfSelectedJobs.id,
        })
          .then(() => {
            this.isLoading = false;
            this.lazyLoadCandidates = this.getManagerCandidates;
          })
          .catch(err => {
            this.isLoading = false;

            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 8000,
            });
          });
      }
    },
    infiniteHandler($state) {
      axios(`https://jobshark.eu/api/v1/candidate/search`, {
        method: 'post',
        data: {
          page: this.currentPage,
          count: this.pageCount,
          employer_uuid: null,
          'opted-out': false,
        },
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }).then(({ data }) => {
        const list = data.data;
        if (list.length) {
          this.currentPage += 1;
          this.infiniteScrollList.push(...list);
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    getUpdatedHours(upDated) {
      if (upDated !== null) {
        return 'N/A';
      }

      const shortMonthNames = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ];

      const dateOne = new Date();
      const dateTwo = upDated;
      const dateOneObj = new Date(dateOne);
      const dateTwoObj = new Date(dateTwo);
      const milliseconds = Math.abs(dateTwoObj - dateOneObj);
      const hours = milliseconds / 36e5;

      if (hours <= 24) {
        return `${hours.toFixed()} hours ago`;
      }

      return `${dateTwoObj.getDay()}-${
        shortMonthNames[dateTwoObj.getMonth()]
      }-${dateTwoObj.getFullYear()}`;
    },
    nextPage() {
      if (this.currentPage >= 1) {
        this.isLoading = true;
        this.currentPage++;

        this.retrieveManagerCandidates({
          search_word: this.searchText,
          page: this.currentPage,
          count: this.pageCount,
          selectedJob: this.listOfSelectedJobs.id,
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(err => {
            this.isLoading = false;

            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 8000,
            });
          });
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.isLoading = true;
        --this.currentPage;

        this.retrieveManagerCandidates({
          search_word: this.searchText,
          page: this.currentPage,
          count: this.pageCount,
          selectedJob: this.listOfSelectedJobs.id,
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(err => {
            this.isLoading = false;

            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 8000,
            });
          });
      } else {
        this.currentPage = 1;
      }
    },
    setPageByNumber(pageNumber) {
      if (pageNumber > this.getTotalPages || pageNumber < 1) return;
      this.isLoading = true;
      this.currentPage = pageNumber;

      this.retrieveManagerCandidates({
        search_word: this.searchText,
        page: this.currentPage,
        count: this.pageCount,
        selectedJob: this.listOfSelectedJobs.id,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;

          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
    setToFirstPage() {
      this.isLoading = true;
      this.currentPage = 1;

      this.retrieveManagerCandidates({
        search_word: this.searchText,
        page: this.currentPage,
        count: this.pageCount,
        selectedJob: this.listOfSelectedJobs.id,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;

          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
    setToLastPage(lastPage) {
      this.isLoading = true;
      this.currentPage = lastPage;

      this.retrieveManagerCandidates({
        search_word: this.searchText,
        page: this.currentPage,
        count: this.pageCount,
        selectedJob: this.listOfSelectedJobs.id,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;

          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
    getLocation(candidate) {
      if (candidate.city.hasOwnProperty('id') && candidate.country.hasOwnProperty('id')) {
        return `${candidate.city.name}, ${candidate.country.name}`;
      } else {
        return 'N/A';
      }
    },
    getCompetences(competences) {
      let slicedCompetences = competences;

      if (!slicedCompetences) {
        slicedCompetences = [];
      }

      slicedCompetences = competences.slice(0, 5);

      return slicedCompetences;
    },
    getRestCompetences(competences) {
      let restCompetences = competences;

      if (!restCompetences) {
        restCompetences = [];
      }

      restCompetences = competences.slice(5);

      return restCompetences;
    },
  },
  computed: {
    ...mapGetters('managerStoreModule', [
      /* 'getCompetencesFilterList',
      'getEmployersDropdown',
      'getLanguagesList',
      'getCitiesByName',
      'getAllCountries',
      'getCurrentPage',
      'getUserProfile',
      'getCurrentPage',
      'getCandidates',
      'getTotalPages',
      'getSourceList',
      'getToken', */
      'getManagerJobsDropdown',
      'getCurrentPage',
      'getTotalPages',
      'getManagerCandidates',
      'getManagerUserProfile',
      'getManagerCandidatesMobile',
    ]),
    getJobListMsg() {
      return MESSAGES.managerNoOPtionsMessage;
    },
  },
  watch: {
    currentPage() {
      localStorage.currentPageCandidateList = this.currentPage;
    },
  },
  mounted() {
    /*  this.displayResultsBasedOnScreen();

    if (localStorage.CandidateListOfSelectedEmployers)
      this.listOfSelectedJobs = JSON.parse(localStorage.CandidateListOfSelectedEmployers);

    if (localStorage.currentPageCandidateList) {
      this.currentPage = Number(localStorage.currentPageCandidateList);
    } */

    this.retrieveManagerUserProfile().then(() => {
      //  this.sendManagerRecent({ candidate_id: this.$route.params.manager_candidate_id });
    });

    //Initial lodaing of candidates list
    this.retrieveManagerCandidates({
      search_word: this.searchText,
      page: this.currentPage,
      count: this.pageCount,
      selectedJob: this.listOfSelectedJobs.id,
    })
      .then(() => {
        this.isLoading = false;
        this.lazyLoadCandidates = this.getManagerCandidates;
        this.retrieveManagerJobsDropdown().then(() => {
          this.isJobsLoading = false;
        });
      })
      .catch(err => {
        this.isLoading = false;

        this.$toasted.error(errorService(err), {
          theme: 'bubble',
          icon: 'fa-times-circle',
          position: 'bottom-right',
          duration: 8000,
        });
      });
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.welcome-text {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  h3 {
    width: 42%;
    color: #666;
  }
}

.custom-label {
  line-height: 40px;
  position: absolute;
  right: 70px;
  top: 0;
  bottom: 0;
  -moz-transition: 0.3s right ease;
  -ms-transition: 0.3s right ease;
  -o-transition: 0.3s right ease;
  -webkit-transition: 0.3s right ease;
  transition: 0.3s right ease;
  z-index: 0;
}

#stage {
  .stage-size {
    width: 12px;
    height: 12px;
  }

  .stage-color-new {
    background-color: #4ca7d5;
  }
  .stage-color-draft {
    background-color: #8a8b8a;
  }
  .stage-color-active {
    background-color: #419941;
  }
  .stage-color-expired {
    background-color: #f17931;
  }
  .stage-color-rejected {
    background-color: #f02800;
  }
}

.candidate-list-card {
  height: 73vh;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
#candidate-employment {
  position: relative;
}

table {
  position: relative;
  min-width: 100% !important;
  tr {
    td {
      padding-bottom: 10.4px;
      padding-top: 10.5px;
    }
    th {
      width: 180px;
      &:first-of-type,
      &:nth-of-type(6),
      &:nth-of-type(8) {
        width: 240px;
      }
      &:nth-of-type(3) {
        width: 100px;
      }
      &:nth-of-type(4) {
        width: 120px;
      }
    }
  }

  .candidate-name {
    padding-left: 20px;
  }

  .collapse-competences {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 999;
    background: #fff;
    /*  max-width: 120%; */

    /*  .d-flex {
      padding: 8px 4px;
      flex-wrap: wrap;
    } */

    .no-icon {
      display: inline-block;
      background: #f2f2f2;
      border-radius: 8px;
      padding: 2px 5px;
      margin: 6px;
      font-size: 12px;
      color: #222;
    }
  }
  td {
    &:nth-of-type(2),
    &:nth-of-type(7),
    &:nth-of-type(8) {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.candidate-competences {
  position: relative;
  padding: 0 13px;

  width: 100%;
  .tech-icons {
    width: 100%;
  }
  .icon-container {
    width: 44px;
    height: 44px;
    align-items: flex-end;
    z-index: 999;
  }
  .btn-danger {
    background: none !important;
    box-shadow: none !important;
    border: none !important;
    color: #222 !important;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    text-align: right;
    &:after {
      display: none;
    }
  }
  .dropdown-menu {
    max-width: 100%;
    min-width: 100%;
  }
  .list-inline {
    li {
      width: 50px;
      height: 50px;
      text-align: center;
      overflow: hidden;
    }
  }
  .dropdown {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.labeled {
  padding-top: 15px;

  span {
    font-size: 10px;
    display: inline-block;
    background: #fff;
    padding: 2px 5px;
    border-radius: 8px;
    margin-right: 0;
  }
}

tr {
  &:nth-child(2n) {
    .labeled {
      span {
        background: rgba(0, 0, 0, 0.05);
      }
    }
  }
}

.mobile-only {
  display: none !important;
}

.bottom-controls {
  position: absolute;
  top: 100%;
  left: -1px;
  background: #fff;
  width: 100.12%;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.mobile-list {
  display: none;
}

@media only screen and (min-width: 2100px) {
  .extend-on-bigscreen {
    width: 320px !important;
  }
}

@media only screen and (max-width: 1251px) {
  .card {
    margin-left: 23px !important;
    margin-right: 23px !important;
  }
}
@media only screen and (max-width: 992px) {
  .welcome-text {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    h3 {
      width: 90%;
      color: #666;
    }
  }
  .card {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .table-controls {
    margin-bottom: 0 !important;
    .published {
      margin: 0;
    }
  }
  .integration-group {
    margin-right: 0 !important;
  }
  .controls-wrap {
    display: block !important;
    .mobile-searchable {
      width: 100% !important;
      margin: 12px 0;
    }
    .form-control {
      margin: 15px 0 0 0 !important;
      width: 100% !important;
    }
    .custom-checkbox.no-mobile {
      font-size: 14px;
      margin: 15px 0 0 0;
      display: none !important;
    }
    .custom-checkbox.mobile {
      font-size: 15px;
      margin: 14px 0 0 0;
    }
  }
  .desktop-only,
  .desktop-only-table {
    display: none;
  }
  .mobile-only {
    display: block !important;
  }
  .empl {
    width: 100%;
    margin-right: 0 !important;
  }
}
.vs__dropdown-toggle {
  min-height: 38px;
}
@media only screen and (max-width: 768px) {
  .table-controls {
    margin-bottom: 0 !important;
    .published {
      margin: 0;
    }
  }
  .integration-group {
    margin-right: 0 !important;
  }

  .controls-wrap {
    display: block !important;
    .mobile-searchable {
      width: 100% !important;
      margin: 12px 0;
    }
    .form-control {
      margin: 15px 0 0 0 !important;
      width: 100% !important;
    }
    .custom-checkbox.no-mobile {
      font-size: 14px;
      margin: 15px 0 0 0;
      display: none !important;
    }
    .custom-checkbox.mobile {
      font-size: 15px;
      margin: 14px 0 0 0;
    }
  }
  .desktop-only,
  .desktop-only-table {
    display: none;
  }

  .hide-on-mobile {
    display: none;
  }

  .bottom-controls {
    position: relative;
    top: 0;
    bottom: 0 !important;
    .ml-auto {
      margin-left: auto !important;
      margin-right: auto !important;
    }
  }

  .mobile-list {
    display: block;
    overflow-y: auto;
    .mobile-list-item {
      padding: 18px;
      border-bottom: 3px solid rgb(233, 233, 233);
      font-family: Lato, Roboto, 'Helvetica Neue', Arial, sans-serif;

      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        a {
          font-weight: 600;
        }
        .location {
          font-size: 14px;
        }
        .date {
          font-size: 14px;
          text-align: right;
        }
      }
      .tech-icons {
        margin-top: 12px;
        .icon-container {
          margin-right: 25px;
        }
      }
    }
  }
}

@media only screen and (max-width: 576px) {
  .no-data-message {
    display: none;
  }
  .bottom-controls {
    display: none !important;
  }
  .card {
    border-top-left-radius: 18px !important;
    border-top-right-radius: 18px !important;
  }
  .table-controls {
    margin-bottom: 0 !important;
    .published {
      margin: 0;
    }
  }
  .integration-group {
    margin-right: 0 !important;
  }

  .controls-wrap {
    display: block !important;
    .mobile-searchable {
      width: 100% !important;
      margin: 12px 0;
    }
    .form-control {
      margin: 15px 0 0 0 !important;
      width: 100% !important;
    }
    .custom-checkbox.no-mobile {
      font-size: 14px;
      margin: 15px 0 0 0;
      display: none !important;
    }
    .custom-checkbox.mobile {
      font-size: 15px;
      margin: 14px 0 0 0;
    }
  }
}
@media only screen and (max-width: 500px) {
  .btn-success.mobile-only {
    display: none !important;
  }
}
/* Filters */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* form-control style fix for custom v-select component */
/* /deep/ .filter-item .vs--searchable .vs__dropdown-toggle {
  height: calc(1.5em + 0.75rem + 2px);
} 
/* End Filters */

/* form-control style fix for custom v-select component */
.vs--searchable .vs__dropdown-toggle {
  height: calc(1.5em + 0.75rem + 2px);
}

.col-md-8.filter {
  color: #6c757d;
  margin-bottom: 12px;
  font-family: $font-family-sans-lato;
}

.filter-select {
  min-width: 200px;
  max-width: 200px;
  margin-right: 6px !important;
  padding-bottom: 8px;
}
</style>
